// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "default-passive-events"; //处理控制台报黄色 冲突

import ElementUI from "element-ui";
import "./styles/common.css";
import "@/styles/whole.css";
import "./styles/varibles.styl"; // 全局变量

import "element-ui/lib/theme-chalk/index.css";
// 全局按钮节流
import { preventReClick } from "@/utils/preventReClick";
Vue.prototype.$preventReClick = preventReClick; // 节流函数

import { Message } from "element-ui";
import VueI18n from "vue-i18n";
import zh from "./langs/zh";
import en from "./langs/en";
import jp from "./langs/jp";
import VueCropper from "vue-cropper";
import {
  setToken,
  getToken,
  setUserId,
  setUserName,
  setNickName,
  setRealName,
  setAvatarPath,
  setPhone,
  setEmail,
  setRoleId,
  clearCookie
} from "@/utils/auth";

Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(VueCropper);
Vue.use(VueI18n);

var url = document.location.href; // 获取url完整路径
var theRequest = {};
if (url.indexOf("?") != -1) {
  var str = url.substr(url.indexOf("?") + 1);
  var strs = str.split("&");
  for (var i = 0; i < strs.length; i++) {
    var st = strs[i].split("=");
    if (st.length > 1) theRequest[st[0]] = st[1];
  }
}

// if (theRequest.lang) {
//   localStorage.setItem("lang", theRequest.lang);
// }
if(location.hostname.toLowerCase().includes('bunka-tech')){
  localStorage.setItem("lang", 'jp');
}else if(location.hostname.toLowerCase().includes('wentech')){
  localStorage.setItem("lang", 'en');
}else{
  localStorage.setItem("lang", 'en');
}
const i18n = new VueI18n({
  // 从本地存储中取，如果没有默认为中文，
  // 这样可以解决切换语言后，没记住选择的语言，刷新页面后还是默认的语言
  //   localStorage.getItem("lang") || 'en';

  locale: localStorage.getItem("lang") || "en",

  // locale: "en",
  messages: {
    // zh: zh, // 中文语言包
    en: en, // 英文语言包
    jp: jp // 日文语言包
  }
});

Vue.prototype.openLoading = function(data) {
  console.log(data);
  const loading = this.$loading({
    // 声明一个loading对象
    lock: true, // 是否锁屏
    text: data ? data : "上传中，请稍等！", // 加载动画的文字
    spinner: "el-icon-loading", // 引入的loading图标
    background: "rgba(0, 0, 0, 0.8)", // 背景颜色
    target: ".el-table, .table-flex, .region", // **需要遮罩的区域，这里写要添加loading的选择器**
    fullscreen: false,
    customClass: "loadingclass" // **遮罩层新增类名，如果需要修改loading的样式**
  });
  return loading;
};

router.beforeEach(async (to, from, next) => {
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari
  window.pageYOffset = 0;

  if (!getToken()) {
    if (theRequest.code) {
      const tokenResponse = await gettoken(theRequest.code);
      if (tokenResponse.code === 1) {
        const { accessToken } = tokenResponse.data;
        setToken(accessToken);
        const userInfoResponse = await userinfo();
        if (userInfoResponse.code === 1) {
          const {
            userId,
            username,
            nickName,
            realName,
            avatarPath,
            phone,
            email,
            roleId
          } = userInfoResponse.data;
          setUserId(userId);
          setUserName(username);
          setNickName(nickName);
          setRealName(realName);
          setAvatarPath(avatarPath);
          setPhone(phone);
          setEmail(email);
          setRoleId(roleId);
        }
        next("/application_center");
        return; // Prevent further execution of the next() call
      }
    } else {
      next();
      return;
    }
  }
  next(); // Always call next() to proceed with the navigation
});
const curLang = localStorage.getItem("lang") || "en";
document.title = curLang == "en" ? 'WenTech' : 'BUNKA'
new Vue({
  el: "#app",
  i18n,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js